import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { guardarCodigoReutilizableComponent } from './guardar-codigo-reutilizable.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { guardarCodigoReutilizableRouting } from './guardar-codigo-reutilizable-routing.component';
import { NgModule } from '@angular/core';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, 'assets/i18n/formulario/', '.json');
  }
  
  
  @NgModule({
    declarations: [guardarCodigoReutilizableComponent],
    imports: [
      guardarCodigoReutilizableRouting,
      SharedModule,
      CommonModule,
      TranslateModule.forChild({
        loader: {
          provide: TranslateLoader,
          useFactory: (createTranslateLoader),
          deps: [HttpClient]
        },
        isolate: true
      })
    ],
    entryComponents: []
  })

  export class guardarCodigoReutilizableModule{}